import React, { Component } from "react"
import PropTypes from "prop-types"
import { translate } from "react-i18next"
import { connect } from "react-redux"
import { compose } from "redux"
import Dashboard from "../../components/Dashboard"
import {
  completionHasData,
  keyItemDataHasData,
  arrayValuesHaveData,
  tempCheckResponseHasData,
  tempCheckScoresHaveResults,
  arrayOfItemNameValuePairsHasData
} from "../../utils/object-utils"
import {
  ReviewAgreement,
  TemperatureCheckScores,
  NumberOfLogins,
  TemperatureCheckResponseRate,
  CoffeeChatsCompleted,
  TopUsedFeatures,
  Completion
} from "../../components/widgets"
import { ENDPOINTS } from "../../constants"

class ActivityAndGeneralStatsDashboard extends Component {
  static propTypes = {
    onReload: PropTypes.func.isRequired
  }

  state = {
    // TODO: widget interraction state to go here, e.g. active nine box grid box
    // but beware you might need to pass this down to WidgetContainer in the renderData
    // prop to get `shouldComponentUpdate` to equate to true
  }

  render() {
    const { t, onReload } = this.props // eslint-disable-line react/prop-types
    const { isLoading, errorMessageKey, widgets, loadingFailed } = this.props.dashboard // eslint-disable-line
    const title = t("Dashboards.Names.ActivityAndGeneralStats")

    return (
      <Dashboard
        errorMessageKey={errorMessageKey}
        isLoading={isLoading}
        loadingFailed={loadingFailed}
        onReload={onReload}
        title={title}
        widgetData={widgets}
      >
        {tempCheckResponseHasData(widgets.temperatureCheckResponseRate.data) && (
          <TemperatureCheckResponseRate
            data={widgets.temperatureCheckResponseRate.data}
            appliedFilters={widgets.temperatureCheckResponseRate.filters}
            exportEndpoint={ENDPOINTS.Export.TemperatureCheckResponseRate}
            subtitleKey={widgets.temperatureCheckResponseRate.subtitle}
          />
        )}

        {tempCheckScoresHaveResults(widgets.temperatureCheckScores.data) && (
          <TemperatureCheckScores
            data={widgets.temperatureCheckScores.data}
            appliedFilters={widgets.temperatureCheckScores.filters}
            exportEndpoint={ENDPOINTS.Export.TemperatureCheckScores}
            subtitleKey={widgets.temperatureCheckScores.subtitle}
            sampleSize={widgets.temperatureCheckScores.sampleSize}
          />
        )}

        {completionHasData(widgets.reviewsCompleted.data) && (
          <Completion
            data={widgets.reviewsCompleted.data}
            appliedFilters={widgets.reviewsCompleted.filters}
            exportEndpoint={ENDPOINTS.Export.ReviewsCompleted}
            subtitleKey={widgets.reviewsCompleted.subtitle}
          />
        )}

        {arrayValuesHaveData(widgets.numberOfLogins.data) && (
          <NumberOfLogins
            data={widgets.numberOfLogins.data}
            appliedFilters={widgets.numberOfLogins.filters}
            exportEndpoint={ENDPOINTS.Export.Logins}
            subtitleKey={widgets.numberOfLogins.subtitle}
          />
        )}

        {arrayOfItemNameValuePairsHasData(widgets.coffeeChatsCompleted.data) && (
          <CoffeeChatsCompleted
            data={widgets.coffeeChatsCompleted.data}
            appliedFilters={widgets.coffeeChatsCompleted.filters}
            exportEndpoint={ENDPOINTS.Export.CoffeeChatsCompleted}
            subtitleKey={widgets.coffeeChatsCompleted.subtitle}
          />
        )}

        {keyItemDataHasData(widgets.reviewAgreement.data) && (
          <ReviewAgreement
            data={widgets.reviewAgreement.data}
            appliedFilters={widgets.reviewAgreement.filters}
            exportEndpoint={ENDPOINTS.Export.ReviewAgreement}
            subtitleKey={widgets.reviewAgreement.subtitle}
            sampleSize={widgets.reviewAgreement.sampleSize}
          />
        )}

        {keyItemDataHasData(widgets.topUsedFeatures.data) && (
          <TopUsedFeatures
            data={widgets.topUsedFeatures.data}
            appliedFilters={widgets.topUsedFeatures.filters}
            exportEndpoint={ENDPOINTS.Export.TopUsedFeatures}
            subtitleKey={widgets.topUsedFeatures.subtitle}
          />
        )}
      </Dashboard>
    )
  }
}

function mapStateToProps(state) {
  return {
    dashboard: state.activityAndGeneralStats
  }
}

export default compose(translate(), connect(mapStateToProps))(ActivityAndGeneralStatsDashboard)



// WEBPACK FOOTER //
// ./src/routes/dashboards/ActivityAndGeneralStatsDashboard.jsx